import React from 'react';

import styled from 'styled-components';

const FontStyle = styled.div`
	.font {
		display: flex;
		flex-direction: column;
		width: 230px;
		height: 300px;
		border: 1px solid black;
		margin: 10px;
		padding: 10px;
		.font-row {
			height: 40px;
			margin-top: 5px;
			.label {
				min-width: 95px;
			}
			display: flex;
			flex-wrap: wrap;
		}
		.font-example,
		.font-name {
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.font-example {
			margin-top: 20px;
		}
		.font-name {
			background-color: ${props => props.theme.Cool_Gray_Light_2};
			height: 40px;
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const Font = ({ font }) => {
	return (
		<FontStyle>
			<div className='font'>
				<pre>
					<div className='font-name heading30'>{font.name}:</div>
					<div className='font-row'>
						<div className='label body10'>Font:</div>
						<div className='value body10'>{font.fontName}</div>
					</div>
					<div className='font-row'>
						<div className='label body10'>Font Sizes:</div>
						<div className='value body10'>{font.fontSizes}</div>
					</div>
					<div className='font-row'>
						<div className='label body10'>Line Height:</div>
						<div className='value body10'>{font.lineHeight}</div>
					</div>
					<div className='font-row'>
						<div className='label body10'>Letter Spacing:</div>
						<div className='value body10'>{font.letterSpacing}</div>
					</div>
				</pre>
				<div className={`font-example ${font.font}`}>Example Text</div>
			</div>
		</FontStyle>
	);
};
